import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public getValue = (key: string) => {
    return localStorage.getItem(key);
  };

  public setValue = (key: string, value: string) => {
    localStorage.setItem(key, value);
  };

  public removeItem = (key: string) => {
    localStorage.removeItem(key);
  };
}
